import { render } from "./AppMessagePhotoSelector.vue?vue&type=template&id=34fb1322&scoped=true&ts=true"
import script from "./AppMessagePhotoSelector.vue?vue&type=script&lang=ts"
export * from "./AppMessagePhotoSelector.vue?vue&type=script&lang=ts"

import "./AppMessagePhotoSelector.vue?vue&type=style&index=0&id=34fb1322&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fb1322"]])

export default __exports__